// src/pages/Watchlist/index.js
import React, { useState } from 'react'
import styles from './styles.module.scss'
import { intl } from 'src/i18n'
import { MainLayout } from 'src/layouts'
import WatchlistItem from './components/WatchlistItem'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import { addNewWatchListTab, addRecommendedSets } from 'src/redux/thunks'
import {
  isWalletInstalled,
  getCoinsFromLocalWallet,
} from 'src/services/walletService'
import { Loader } from 'src/components/Loader'

const Watchlist = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const handleCreateWatchlist = async type => {
    const newWatchlistId = await dispatch(addNewWatchListTab())

    if (newWatchlistId) {
      if (type === 'metamask') {
        handleAddWalletTokens(newWatchlistId)
      } else {
        router.push(`/watchlist/${newWatchlistId}`)
      }
    } else {
      alert('Cannot create more than 10 watchlists.')
    }
  }

  const handleAddWalletTokens = async watchlistId => {
    if (isWalletInstalled()) {
      setIsLoading(true)
      const tokens = await getCoinsFromLocalWallet()
      const tokensConfig = {
        text: intl.t('watchList.components.emptyTap.config.walletTokens'),
        actionData: { tokens },
      }
      await dispatch(addRecommendedSets(tokensConfig))
      setIsLoading(false)
      router.push(`/watchlist/${watchlistId}`)
    } else {
      router.push('/news/how-to-connect-metamask-wallet-to-coin360')
    }
  }

  return (
    <MainLayout>
      {isLoading && <Loader isActive={isLoading} />}
      <div className={styles.main}>
        <div className={styles.header}>
          <h1>{intl.t('watchList.components.emptyTap.createHeader')}</h1>
          <h3>{intl.t('watchList.components.emptyTap.createSubHeader')}</h3>
        </div>
        <div className={styles.itemContainer}>
          <WatchlistItem
            src='/assets/icons/icon-add-plus.svg'
            alt='add'
            text={intl.t('watchList.components.emptyTap.build')}
            onClick={() => handleCreateWatchlist('build')}
          />
          <WatchlistItem
            src='/assets/Metamask-icon.svg'
            alt='metamask'
            text={intl.t('watchList.components.emptyTap.sync')}
            onClick={() => handleCreateWatchlist('metamask')}
          />
        </div>
      </div>
    </MainLayout>
  )
}

export default Watchlist
